export function BucketIcon() {
	return <div data-cy={'bucket-icon'} className='action-icon'>
		<svg width='11' height='14' viewBox='0 0 11 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M0.75 12C0.75 12.825 1.425 13.5 2.25 13.5H8.25C9.075 13.5 9.75 12.825 9.75 12V3H0.75V12ZM10.5 0.75H7.875L7.125 0H3.375L2.625 0.75H0V2.25H10.5V0.75Z'
				fill='#0088CC'/>
		</svg>
	</div>;
}